import React, { useState } from "react";
import { PaginationItem, PaginationLink } from "reactstrap";
import { Link } from "react-router-dom";
import { Pagination } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import FullfillmentDialog from "Pages/Profile/fullfillmentDialog";
import ViewCustomArtRequest from "./viewCustomArtRequest";
const CustomArtRequest = () => {
      const [ViewArt, setViewArt] = useState(false);
      const eyeBtn = (item) => {
        if (ViewArt === false) {
          //   setPrintRequest(item)
        } else {
          //   setPrintRequest()
        }
    
        setViewArt(!ViewArt);
      };
  return (
    <>
      <h1 className="mb-0">
        <i className="fa-light fa-bars-sort"></i> Custom Art Request{" "}
      </h1>
      <div className=" mt-4">
        <div className="table-responsive tableNft">
          <table>
            <thead>
              <tr>
                <td className="date-div-table">
                  Date <img src="../../images/svg/color-filter.svg" />
                </td>
                <td>Description</td>
                <td>
                  Amount <img src="../../images/svg/color-filter.svg" />
                </td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody >
              <>
              <tr>
                                <td colSpan={8}>
              <div className="text-center d-grid justify-content-center dataNotFound py-5">
                    <img
                      src={"../../images/svg/mpdatanft.svg"}
                      alt="Create collection"
                    />
                    <h3>No Custom  Art Requests</h3>
                  </div>
                  </td>
                  </tr>
                {/* <tr>
                  <td>23 July 2023</td>
                  <td>
                    Pour toute question ou besoin d'assistance, n'hésitez pas à
                    nous appeler au 02 34 56 78 90{" "}
                    <span className="view-more-text">view more...</span>
                  </td>
                  <td>$1,200</td>
                  <td>
                   <img
                    className="d-block m-auto"
                    src="../../images/svg/Eye.svg"
                    onClick={eyeBtn}
                    alt="Open Tracker"
                  />

                  <Modal
                    className="EmailVerifyBoxModel printDialog "
                    show={ViewArt}
                    centered
                    animation={false}
                    onHide={() => setViewArt(false)}
                  >
                <ViewCustomArtRequest handleClose={() => setViewArt(false)} />
                  </Modal>
                  </td>
                </tr>
                    <tr>
                  <td>23 July 2023</td>
                  <td>
                    Pour toute question ou besoin d'assistance, n'hésitez pas à
                    nous appeler au 02 34 56 78 90{" "}
                    <span className="view-more-text">view more...</span>
                  </td>
                  <td>$1,200</td>
                    <td>
                    {" "}
                    <img
                      className="d-block m-auto"
                      src="../../images/svg/Eye.svg"
                    
                      alt="Open Tracker"
                    />
                  </td>
                </tr>
                    <tr>
                  <td>23 July 2023</td>
                  <td>
                    Pour toute question ou besoin d'assistance, n'hésitez pas à
                    nous appeler au 02 34 56 78 90{" "}
                    <span className="view-more-text">view more...</span>
                  </td>
                  <td>$1,200</td>
                  <td>
                    {" "}
                    <img
                      className="d-block m-auto"
                      src="../../images/svg/Eye.svg"
                    
                      alt="Open Tracker"
                    />
                  </td>
                </tr>
                    <tr>
                  <td>23 July 2023</td>
                  <td>
                    Pour toute question ou besoin d'assistance, n'hésitez pas à
                    nous appeler au 02 34 56 78 90{" "}
                    <span className="view-more-text">view more...</span>
                  </td>
                  <td>$1,200</td>
                  <td>
                    {" "}
                    <img
                      className="d-block m-auto"
                      src="../../images/svg/Eye.svg"
                    
                      alt="Open Tracker"
                    />
                  </td>
                </tr>
                    <tr>
                  <td>23 July 2023</td>
                  <td>
                    Pour toute question ou besoin d'assistance, n'hésitez pas à
                    nous appeler au 02 34 56 78 90{" "}
                    <span className="view-more-text">view more...</span>
                  </td>
                  <td>$1,200</td>
                  <td>
                    {" "}
                    <img
                      className="d-block m-auto"
                      src="../../images/svg/Eye.svg"
                    
                      alt="Open Tracker"
                    />
                  </td>
                </tr>
                    <tr>
                  <td>23 July 2023</td>
                  <td>
                    Pour toute question ou besoin d'assistance, n'hésitez pas à
                    nous appeler au 02 34 56 78 90{" "}
                    <span className="view-more-text">view more...</span>
                  </td>
                  <td>$1,200</td>
                  <td>
                    {" "}
                    <img
                      className="d-block m-auto"
                      src="../../images/svg/Eye.svg"
                    
                      alt="Open Tracker"
                    />
                  </td>
                </tr> */}
              </>
            </tbody>
          </table>
             {/* <Pagination
            className="paginationNew"
            aria-label="Page navigation example"
          >
            <div className="d-flex align-items-center gap-2">
              <PaginationItem>
                <PaginationLink first href="#" />
              </PaginationItem>
              <PaginationItem>
                <PaginationLink previous href="#" />
              </PaginationItem>
            </div>

            <PaginationItem>
              <PaginationLink href="#">1</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href="#">2</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href="#">3</PaginationLink>
            </PaginationItem>

            <div className="d-flex">
              <PaginationItem>
                <PaginationLink next href="#" />
              </PaginationItem>
              <PaginationItem>
                <PaginationLink last href="#" />
              </PaginationItem>
            </div>
          </Pagination> */}
        </div>
      </div>
    </>
  );
};

export default CustomArtRequest;
